import React, { useState } from 'react'
import { Select, IconButton, Tooltip, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

/**
 * A reusable component for selecting contract status with confirm/cancel actions
 *
 * @param {string} status - Current status value
 * @param {object} contract - Contract object
 * @param {function} onStatusChange - Function to call when status changes
 * @param {boolean} showIcons - Whether to show confirm/cancel icons
 * @param {function} onUpdate - Function to call when confirming status update
 * @param {function} onCancel - Function to call when canceling status update
 */
const ContractStatusSelector = ({
  status,
  onStatusChange,
  showIcons,
  onUpdate,
  onCancel,
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Select
          id="contractStatus"
          name="contractStatus"
          value={status}
          onChange={onStatusChange}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          MenuProps={{
            PaperProps: {
              style: {
                transform: 'translateY(10px)',
              },
            },
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          }}
        >
          <MenuItem value="ACTIVE">{t('LBLActive')}</MenuItem>
          <MenuItem value="INACTIVE">{t('LBLExpired')}</MenuItem>
          <MenuItem value="IN_PROGRESS">{t('LBLInreview')}</MenuItem>
        </Select>
      </div>

      {showIcons && (
        <div
          style={{ display: 'flex', flexDirection: 'row', marginLeft: '8px' }}
        >
          <Tooltip title="Confirm">
            <IconButton onClick={onUpdate}>
              <CheckIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancel">
            <IconButton onClick={onCancel}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export default ContractStatusSelector
